module.exports = __webpack_public_path__ + "static/media/cx.09db1384.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cx.svg
// module id = 95
// module chunks = 0